import React from 'react';
import { classes } from './LogoSection.st.css';
import { FormType } from '../../../types/types';
import { useLogoSettings } from './useLogoSettings';

interface LogoSectionProps {
  formType: FormType;
}

export const LogoSection = ({ formType }: LogoSectionProps) => {
  const { logoUrl, logoAltText } = useLogoSettings({ formType });

  if (!logoUrl) {
    return null;
  }

  return (
    <div data-hook={`${formType}-logo`} className={classes.logoSection}>
      <img
        src={logoUrl}
        alt={logoAltText}
        className={classes.logoImage}
        data-hook={`${formType}-logo-image`}
      />
    </div>
  );
};
